@if (elsJobStatistics(); as elsJobStatistics) {
  <bxi-els-import-status-report></bxi-els-import-status-report>
} @else {
  <div class="gap-xl flex w-full flex-col items-center justify-center pt-20">
    <bx-file-upload
      acceptedFileTypes=".json"
      (fileChanged)="onFileChanged($event)"
      [content]="contentInfo"
      [inputAriaLabel]="'elsImport.aria.fileUpload' | translate"
    >
      <ng-template #contentInfo>
        <div class="text-text-tertiary-600 flex flex-col items-center text-sm">
          <p><span class="text-button-tertiary-color-fg">Click to upload</span> or drag and drop</p>
          <p>JSON</p>
        </div>
      </ng-template>
    </bx-file-upload>

    @if (filesToUpload(); as files) {
      <button bx-button iconTrailing="upload-03" (click)="readFile(files.item(0)!)" [disabled]="uploading()">
        {{ 'elsImport.upload' | translate }}
      </button>
    }

    @if (errorKey(); as errorKey) {
      <p class="text-error-700 text-sm font-medium">{{ errorKey | translate }}</p>
    }
  </div>
}
